/**
 * RecentsSection.jsx — ELYON-SHELL-FOUNDATION-1
 *
 * Renders the "Recents" section in the sidebar.
 * Hidden when collapsed or when no recents exist.
 * SIDEBAR-IMPORT-GATE: only Clock from lucide-react.
 */
import { Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useRecents } from '../stores/recentsStore.js';

/**
 * @param {{ isCollapsed: boolean }} props
 */
export function RecentsSection({ isCollapsed }) {
  const recents = useRecents();

  // Not rendered in collapsed or empty state
  if (recents.length === 0 || isCollapsed) return null;

  return (
    <div
      className="elyon-sidebar-section"
      role="region"
      aria-label="Recently visited"
    >
      <span className="elyon-sidebar-section-label" aria-hidden="true">
        Recents
      </span>
      <ul className="elyon-recents-list" role="list">
        {recents.slice(0, 5).map((r) => (
          <li key={`${r.entityType}-${r.entityId}`}>
            <Link
              to={r.route}
              className="elyon-recents-item"
              aria-label={`${r.title} — ${r.breadcrumb}`}
            >
              <div className="elyon-recents-item-row">
                <Clock
                  size={12}
                  strokeWidth={1.5}
                  aria-hidden="true"
                  style={{ color: 'var(--color-text-tertiary)', flexShrink: 0 }}
                />
                <span className="elyon-recents-title">{r.title}</span>
              </div>
              {r.breadcrumb && (
                <span className="elyon-recents-breadcrumb">{r.breadcrumb}</span>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
